<template>
  <div id="CalendarioAgendaDeAudiencias_div" class="padding-div-low">
    <div class="card-header">
      <h3 v-if="mostrarTemporizador" class="text-form" style="float: right;">
        {{ obtenerTemporizadorFechaHoraSeleccionadoCuenta.format("mm:ss") }}
      </h3>
      <h4>Calendario de citas a juzgado</h4>
      </div>
    <div class="area card-body">      
      <h6 class="text-form">Seleccione una fecha y hora para agendar su cita.</h6>
      <hr />
      <div id="calendario">
        <full-calendar
          id="calendario_agendar_siccij"
          v-if="cargarFullCalendar"
          :events="eventosFullCalendar"
          :config="configuracionFullCalendar"
          ref="calendar"
          @event-selected="calendarioEventoClic"
        ></full-calendar>
      </div>
      <hr />
      <!-- <div class="clearfix">
                <div class="float-left ancho_botones">
                    <button type="button" class="btn btn-primary" @click="cancelarCita()"><i class="far fa-calendar-times fa-lg"></i>&nbsp;&nbsp;Cancelar cita</button>
                </div> 
                <div v-if="agendaBloqueSeleccionadoId != 0" class="float-right ancho_botones">
                    <button type="button" class="btn btn-primary" @click="crearObjetoYAgendar()"><i class="far fa-calendar-check fa-lg"></i>&nbsp;&nbsp;Agendar</button>
                </div> 
                <div class="float-right ancho_botones">
                    <button type="button" class="btn btn-primary mr-3" @click="regresarAListadoDeTramites()"><i class="fas fa-arrow-alt-circle-left fa-lg"></i>&nbsp;&nbsp;Regresar</button>
                </div> 
            </div> -->
      <div class="d-flex row">
        <div class="col-12 col-sm-5 col-md-4 col-lg-4 col-xlg-4 pb-2 text-left">
          <button
            type="button"
            class="btn btn-primary overwrapDeBotones"
            @click="cancelarCita()"
          >
            <i class="far fa-calendar-times fa-lg"></i>&nbsp;&nbsp;Cancelar cita
          </button>
        </div>
        <div class="d-sm-none d-md-none d-lg-block col-lg-1 col-xlg-1"></div>
        <div
          class="col-12 col-sm-7 col-md-8 col-lg-7 col-xlg-7 pb-1 text-right"
        >
          <button
            type="button"
            class="btn btn-primary overwrapDeBotones mb-1"
            @click="regresarAListadoDeTramites()"
          >
            <i class="fas fa-arrow-alt-circle-left fa-lg"></i
            >&nbsp;&nbsp;Regresar
          </button>
          <button
            v-if="agendaBloqueSeleccionadoId != 0"
            type="button"
            class="btn btn-primary overwrapDeBotones mb-1"
            @click="crearObjetoYAgendar()"
          >
            <i class="far fa-calendar-check fa-lg"></i>&nbsp;&nbsp;Agendar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import enumeraciones from "@/../static/js/enumeraciones";
import catalogos from "@/../static/js/catalogos";
import FullCalendar from "@/../static/js/fullcalendar";
import api from "@/../static/js/api";
import comun from "@/../static/js/comun";
import axios from "axios";

export default {
  components: {
    FullCalendar
  },
  data() {
    return {
      enumeraciones,
      mostrarTemporizador: false,
      agendaBloqueSeleccionadoId: 0,
      keyCalendario: 0,
      cargarFullCalendar: false,
      agendaEventoBloqueSeleccionado: {},
      agendaBloqueSeleccionadoCurrentTarget: {},
      elementoSeleccionado: "",
      funcionActivacion: "cargaBloquesCalendario()",
      eventosFullCalendar: [],
      configuracionFullCalendar: {
        slotLabelFormat: "h:mma",
        header: {
          left: "prev,today,next",
          center: "title",
          right: "month,agendaWeek,agendaDay"
        },
        defaultView: "month",
        editable: false,
        businessHours: {
          daysOfWeek: [1, 2, 3, 4, 5], // Monday - Friday
          start: "08:00:00", // a start time (10am in this example)  parametros.horarioAtencionInicio
          end: "16:00:00" // an end time (6pm in this example) parametros.horarioAtencionFinal
        },
        defaultDate: moment()
          .add(1, "days")
          .format("YYYY-MM-DD"),
        selectConstraint: "businessHours",
        weekends: false,
        minTime: "07:30",
        maxTime: "18:00",
        allDaySlot: false,
        defaultTimedEventDuration: "00:30:00",
        slotDuration: "00:30:00",
        slotLabelInterval: 15,
        selectable: false,
        contentHeight: "auto"
      }
    };
  },
  props: {
    parametros: {
      peticion: Object,
      horarioAtencionInicio: String,
      horarioAtencionFinal: String,
      tiempoEntreBloques: String
    }
  },
  mounted: function() {},
  methods: {
    /**
     * Función encargada de llamar a API para cargar los bloques del calendario.
     */
    cargaBloquesCalendario: function() {
      comun.SeEstaCargandoInformacion(true);
      this.parametros.peticion.EsPrueba = this.enumeraciones.EsPrueba;
      const headerPeticion = comun.CrearElHeaderDeAutorizacion(
        this.$store.state.Login_AutorizacionOriginal,
        false
      );

      axios
        .post(
          api.conexion +
            api.SICCIJ.sistema.citas.AgendarCita.ObtenerAgendaEventosBloques,
          this.parametros.peticion,
          headerPeticion
        )
        .then(respuesta => {
          if (
            respuesta.data.AgendaEventosBloques != undefined &&
            respuesta.data.AgendaEventosBloques != null &&
            respuesta.data.AgendaEventosBloques.length > 0
          ) {
            this.configuracionFullCalendar.businessHours.start = this.parametros.horarioAtencionInicio;
            this.configuracionFullCalendar.businessHours.end = this.parametros.horarioAtencionFinal;
            this.configuracionFullCalendar.minTime = this.parametros.horarioAtencionInicio;
            this.configuracionFullCalendar.maxTime = this.parametros.horarioAtencionFinal;
            this.configuracionFullCalendar.defaultTimedEventDuration = this.parametros.tiempoEntreBloques;
            this.configuracionFullCalendar.slotDuration = this.parametros.tiempoEntreBloques;
            this.configuracionFullCalendar.defaultDate = moment(
              respuesta.data.FechaInicio
            ).format("YYYY-MM-DD"); //moment().add(1, 'days').format('YYYY-MM-DD')
            this.cargarFullCalendar = true;
            this.mostrarTemporizador = true;
            this.eventosFullCalendar = respuesta.data.AgendaEventosBloques;
            comun.SeEstaCargandoInformacion(false);
          }
          if (respuesta.data.SiHayError) {
            comun.SeEstaCargandoInformacion(false);
            clearInterval(
              this.$store.state
                .SICCIJ_AgendarCita_TemporizadorFechaHoraSeleccionada
            );
            this.$store.state.SICCIJ_AgendarCita_TemporizadorFechaHoraSeleccionada = null;
            this.mostrarTemporizador = false;
            console.log(respuesta);
            if (
              respuesta.data.Error.Mensaje.includes(
                "ya tiene citas agendadas en los días disponibles para este juzgado"
              )
            ) {
              bootbox.dialog({
                title: "Mensaje del sistema",
                message: respuesta.data.Error.Mensaje,
                size: "medium",
                buttons: {
                  aceptar: {
                    label: "Aceptar y cancelar agenda de cita",
                    className: "btn btn-primary",
                    callback: () => {
                      comun.SeEstaCargandoInformacion(true);
                      this.$router.go();
                    }
                  }
                }
              });
            } else
              comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
          }
        })
        .catch(e => {
          console.log("No Hay Respuesta del Servidor" + e);
          comun.SeEstaCargandoInformacion(false);
          clearInterval(
            this.$store.state
              .SICCIJ_AgendarCita_TemporizadorFechaHoraSeleccionada
          );
          this.$store.state.SICCIJ_AgendarCita_TemporizadorFechaHoraSeleccionada = null;
        });
    },
    /**
     * Función encargada de cambiar el css del evento seleccionado y regresar los anteriores a su color original
     * @param {} event []
     * @param {} jsEvent []
     * @param {} view []
     */
    calendarioEventoClic: function(event, jsEvent, view) {
      //console.log(event)
      if (event.title == "Citas Disponibles") {
        if (
          this.agendaEventoBloqueSeleccionado != null &&
          this.agendaEventoBloqueSeleccionado != undefined &&
          this.agendaEventoBloqueSeleccionado != "" &&
          !(Object.keys(this.agendaEventoBloqueSeleccionado).length === 0)
        ) {
          $(this.agendaBloqueSeleccionadoCurrentTarget).css(
            "background-color",
            this.agendaEventoBloqueSeleccionado.backgroundColor
          );
          $(this.agendaBloqueSeleccionadoCurrentTarget)
            .find(".fc-title")
            .text(this.agendaEventoBloqueSeleccionado.title);
          $(this.agendaBloqueSeleccionadoCurrentTarget).css("border", "");
          $(this.agendaBloqueSeleccionadoCurrentTarget).css(
            "font-weight",
            "normal"
          );
        } else {
          if (
            this.obtenerTemporizadorFechaHoraSeleccionadoCuenta > moment(30000)
          )
            this.$store.state.SICCIJ_AgendarCita_TemporizadorFechaHoraSeleccionadaCuenta = moment(
              30000
            );
        }
        $(jsEvent.currentTarget).css("background-color", "rgba(0, 61, 153, 1)");
        $(jsEvent.currentTarget).css("border", "1px solid rgb(0, 61, 153)");
        $(jsEvent.currentTarget).css("font-weight", "bold");
        $(jsEvent.currentTarget)
          .find(".fc-title")
          .text("Seleccionado");
        this.agendaBloqueSeleccionadoId = event.id;
        this.agendaBloqueSeleccionadoCurrentTarget = jsEvent.currentTarget;
        this.agendaEventoBloqueSeleccionado = event;
      }
    },
    /**
     * Función encargada de llamar al componente padre y mandar la fecha y hora seleccionada.
     */
    crearObjetoYAgendar: function() {
      this.$emit("valorParaElPadreFechaHoraDeCita", {
        Siguiente: true,
        AgendaBloqueId: this.agendaBloqueSeleccionadoId
      });
    },
    /**
     * Función encargada de regresar a componente de listado de trámites.
     */
    regresarAListadoDeTramites: function() {
      if (
        this.agendaBloqueSeleccionadoId != null &&
        this.agendaBloqueSeleccionadoId != undefined &&
        this.agendaBloqueSeleccionadoId != 0
      ) {
        bootbox.confirm({
          title: "Mensaje del sistema",
          message:
            "Ya ha seleccionado una fecha y hora para su cita. Si decide regresar a la ventana anterior, no se guardará su selección de horario.<br />¿Desea continuar?",
          buttons: {
            cancel: {
              label: '<i class="fa fa-times"></i>&nbsp;&nbsp;Regresar'
            },
            confirm: {
              label:
                '<i class="fa fa-check"></i>&nbsp;&nbsp;Volver a listado de tramites'
            }
          },
          callback: respuestaRegresarListadoTramites => {
            if (respuestaRegresarListadoTramites)
              this.$emit("valorParaElPadreFechaHoraDeCita", {
                Siguiente: false
              });
          }
        });
      } else
        this.$emit("valorParaElPadreFechaHoraDeCita", { Siguiente: false });
    },
    /**
     * Función encargada de cancelar cita.
     */
    cancelarCita: function() {
      bootbox.confirm({
        title: "Mensaje del sistema",
        message:
          "Hay información agregada. Si decide cancelar su proceso de agendar cita, perderá toda la información ingresada.<br />¿Desea continuar?",
        buttons: {
          cancel: {
            label: '<i class="fa fa-times"></i>&nbsp;&nbsp;Regresar'
          },
          confirm: {
            label:
              '<i class="fa fa-check"></i>&nbsp;&nbsp;Continuar y cancelar cita'
          }
        },
        callback: respuestacancelarCita => {
          if (respuestacancelarCita) this.$router.go();
        }
      });
    }
  },
  created() {
    this.cargaBloquesCalendario();
  },
  computed: {
    obtenerTemporizadorFechaHoraSeleccionadoCuenta() {
      return this.$store.getters
        .Get_SICCIJ_AgendarCita_TemporizadorFechaHoraSeleccionadaCuenta;
    }
  }
};
</script>

<style scoped>
.padding-div-low {
  padding-top: 40px;
}
.alinear_izq {
  float: left;
}
.alinear_der {
  float: right;
}
.contenedor-puntero {
  background: #212529;
  border-radius: 2px;
  padding: 10px;
  border: 1px solid white;
  margin-bottom: 1.5em;
}
</style>

<style scoped>
.padding-div-low {
  padding-top: 40px;
}

#calendario_agendar_siccij .fc-view-container {
  background-color: transparent !important;
  color: #343a40 !important;
  border-color: #212529 !important;
}

#calendario_agendar_siccij .fc-view table {
  border-color: #212529 !important;
}

#calendario_agendar_siccij .fc-axis {
  background-color: #504f54;
  color: black !important;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji",
    "Segoe UI Symbol", "Noto Color Emoji" !important;
}

#calendario_agendar_siccij .fc-day-header {
  background-color:#004746 !important;
  color: black !important;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji",
    "Segoe UI Symbol", "Noto Color Emoji" !important;
  padding: 0.75rem !important;
}

#calendario_agendar_siccij .fc-button {
  background-color: whitesmoke !important;
  border: none !important;
  padding: 0.375rem 1.35rem !important;
  color: #212529 !important;
  text-shadow: none !important;
  display: inline-block !important;
  font-weight: 400 !important;
  text-align: center !important;
  white-space: nowrap !important;
  vertical-align: middle !important;
  font-size: 1rem !important;
  border-radius: 0.25rem !important;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out !important;
}

#calendario_agendar_siccij .fc-state-active {
  background-color: rgb(174, 174, 174) !important;
}

#calendario_agendar_siccij .fc-button:focus {
  outline: none !important;
}

#calendario_agendar_siccij .fc-today {
  background-color: rgba(242, 242, 242, 0.5) !important;
  color: black !important;
}

#calendario_agendar_siccij .fc-day-number {
  color: black !important;
}

#calendario_agendar_siccij .fc-event {
  background-color: #212529;
  border-color: #32383e !important;
  color: white !important;
  padding: 0 0.375rem !important;
  font-size: 1rem !important;
  border-radius: 0.25rem !important;
  width: 80% !important;
  text-align: center !important;
  margin: auto !important;
}
 
   .card-body {
        background-color: #bebebc;
        padding: 2em 2em 2em 2em !important;
        border: 1px solid rgb(44, 44, 44);
    }
   .card-header {
        background-color: #007573;
        border: 1px solid rgb(44, 44, 44);
        
    }
    .text-form {
        color: black;
    }
</style>


// WEBPACK FOOTER //
// src/components/SICCIJ/Citas/AgendarCitas/FechaHoraDeCita.vue